import React from 'react';

import RichText from 'components/RichText/RichText';
import { FaqType } from 'containers/JoinUsPage/JoinUsPage.types';
import useOverElement from 'hooks/useOverElement';
import { useOpportunitiesStore } from 'store';

import * as S from './FaqComponent.styles';

export interface FaqComponentProps {
  title: string;
  description: string;
  ctaLabel: string;
  faq: Array<FaqType>;
}

const defaultProps: Partial<FaqComponentProps> = {};

const FaqComponent: React.FunctionComponent<FaqComponentProps> = ({
  title,
  description,
  ctaLabel,
}) => {
  const { openFaq } = useOpportunitiesStore();

  const [ref] = useOverElement();

  return (
    <S.FaqComponentWrapper ref={ref}>
      <S.Title>
        <RichText as="h3" size="heading3" richText={title} defaultFormatting />
      </S.Title>

      <RichText
        as="p"
        size="smallBody"
        richText={description}
        defaultFormatting
      />
      <S.Button label={ctaLabel} onClick={openFaq} />
    </S.FaqComponentWrapper>
  );
};

FaqComponent.defaultProps = defaultProps;

export default FaqComponent;
